import AOS from "aos"
import parse from "html-react-parser"
import React, { memo, useEffect } from "react"

import SectionsTitle from "../../../Common/new/SectionsTitle"

import { replaceUnderscoresWithSpaces } from "../../../utils/functions"

import { Tab, TabList, TabPanel, Tabs } from "react-tabs"
import * as style from "./whyService.module.css"

const WhyService = props => {
  const {
    capWhyTitle,
    capWhyContent,
    capWhySubTitle,
    capWhyShowSection,
    capWhyIconTextList,
  } = props

  useEffect(() => {
    AOS.init({
      once: true,
    })
  }, [])

  return (
    <>
      {capWhyShowSection === "yes" && (
        <section className={style.why_service_section}>
          <div className="container">
            <div className={style.why_service_content_wrap}>
              <SectionsTitle
                title={replaceUnderscoresWithSpaces(capWhyTitle)}
                SubTitle={parse(`${capWhySubTitle}`)}
                Content={capWhyContent}
                styleCss={{ display: "none" }}
                classnames={`${style.why_service_title} bgBlackHeading`}
              />
              {capWhyIconTextList && <Tabs
                className={style.why_service_tab_wrap}
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <div className={style.tab_list_wrap}>
                  <TabList>
                    {Array.isArray(capWhyIconTextList) &&
                      capWhyIconTextList?.map((item, index) => {
                        return (
                          <Tab>
                            <p>{item?.tabListTitle}</p>
                          </Tab>
                        )
                      })}
                  </TabList>
                </div>
                <div className={style.tab_content_wrap}>
                  {Array.isArray(capWhyIconTextList) &&
                    capWhyIconTextList?.map((item, index) => {
                      return (
                        <TabPanel className={`style.tab_panel`}>
                          <div className={style.inner_tab_content}>
                            <div className={style.title_wrap}>
                              <i className={style.title_icon}>
                                {parse(`${item?.capWhyListIcon}`)}
                              </i>
                              <h3>{item?.tabListTitle}</h3>
                            </div>
                            <div className={style.content_wrap}>
                              {parse(`${item?.capWhyListDescription}`)}
                            </div>
                          </div>
                        </TabPanel>
                      )
                    })}
                </div>
              </Tabs>}
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default memo(WhyService)
